export const loadingOffersText = 'Wir durchsuchen die <b>besten Angebote</b> für Sie.';
export const errorText = 'Es ist ein Fehler aufgetreten. Bitte prüfen Sie Ihre Daten und geben Sie diese erneut ein.';
export const errorPaymentText = {
    default:
        "Leider ist ein Fehler bei der Übermittlung Ihrer Daten aufgetreten. Bitte prüfen Sie Ihre Angaben und versuchen Sie es zu einem späteren Zeitpunkt erneut.<br/> Sollte der Fehler bestehen bleiben, wenden Sie sich bitte an <a href='mailto:accounting@aurumtours.de'>accounting@aurumtours.de</a>.",
    '3dSecure2CardNotReady':
        "Leider unterstützt ihr Kreditkarteninstitut keine Online-Zertifizierungsprüfung, sodass eine Zahlung mit dem ausgewählten Zahlungsmittel nicht gewährleistet werden kann. Bitte wählen Sie ein anderes Zahlungsmittel.<br/> Bei Fragen wenden Sie sich bitte an <a href='mailto:accounting@aurumtours.de'>accounting@aurumtours.de</a>.",
};
export const errorNoOffersText = 'Es wurden keine passende Angebote für Sie gefunden.';

export const paymentAlertText = (
    <>
        <p>
            Ihren aktuellen Zahlungsstatus können Sie in Ihrer Reisebestätigung, die Sie per E-Mail bekommen haben,
            einsehen.
        </p>
        <p>
            Sollten Sie zu Ihrem Zahlungsstatus Fragen haben, dann wenden Sie sich bitte an das AurumTours Serviceteam
            unter{' '}
            <a rel="noopener noreferrer" href="mailto:service@aurumtours.de">
                service@aurumtours.de
            </a>
            .
        </p>
    </>
);
